import React, { useEffect} from "react";
import { connect } from "react-redux";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import UserInfo from "./UserInfo";
import Back from "../../assets/assets/back.svg";
import { useHistory } from "react-router-dom";
import Empty from "../../assets/assets/empty.svg";
import { getUserStatus } from "../../redux/Actions/GetDocsActions";
import POSSingle from "../Certification/POSSingle";
import { getUserTrail, getTestCards } from "../../redux/Actions/PosActions";
import { submitAgreement } from "../../redux/Actions/TestCasesActions";
import Docs from "./Docs";
import Cards from "./Cards";
import { PropTypes } from "prop-types";
import VerifyStaff from "../../components/Dashboard/Verify";


const SingleProductPage = (props) => {

  const history = useHistory();

  const {
    getStatus,
    getStatusSuccess,
    isGetting,
    isGettingCards,
    dashboardData,
    userTrail,
    getUserTrail,
    isFetching,
    isSubmitting,
    submitSuccess,
    submitAgreement,
    getTestCards,
    cards,
    getApplicationHash,
 
  

  } = props;

  const singleDoc = props.location.state;

  useEffect(
    () => {
      getStatus();
      getUserTrail();
      getTestCards();
 

   
    },
    // eslint-disable-next-line
    [getStatus, getUserTrail, getTestCards]
  );



  const showFrame = (id, link, name) => {
    history.push({
      pathname: `/doc/${name}`,
      state: {
        id: id,
        link: link,
        name: name,
      },
    });
  };

  const trail = userTrail && userTrail;
  const trailLength = userTrail?.length;
  const results = cards;
  // NOSONAR:
  const resultsLength = cards && cards[0] && cards[0]?.card_request;
   // NOSONAR:
  const testCardStatus = cards && cards[0] && cards[0]?.count;
   // NOSONAR:
  const status = dashboardData && dashboardData[0] && dashboardData[0]?.default_application;
   // NOSONAR:
  const defaultApp = dashboardData && dashboardData[0] && dashboardData[0]?.default_application;
   // NOSONAR:
  const pos = dashboardData && dashboardData[0] && dashboardData[1]?.pos_application;
   // NOSONAR:
  const companyId =  status && status[0] && status[0]?.company_id;
  const posLength = singleDoc?.posLength;
  const singleDocName =  singleDoc?.name;
  const singleDocId = singleDoc?.id;




  return (
    <div className="container">
      <UserNav />
      <Sidebar />
      <VerifyStaff />
      <div className="container-body2">
        <UserInfo
          status={singleDocName === "POS" ? pos : status}
          isGetting={isGetting}
          defaultApp={defaultApp}
          getStatusSuccess={getStatusSuccess}
        />
      </div>
      <div className="container-body3">
        <div className="dashboard-main">
          <div className="dashboard-main-header-title2">
            <span></span>
            <p>
              <a href="/dashboard">
                <img src={Back} alt="back" /> Back
              </a>
            </p>
          </div>
          <div>
            {!singleDocName && posLength < 2 ? (
              <div className="pos-empty2">
                <div>
                  <img src={Empty} alt="pos-empty2" />
                </div>
                <h1>Network Error</h1>
                <p>Please check back later</p>
              </div>
            ) : (
                <>
                  {singleDocName === "POS" && (
                    <POSSingle
                      trails={trail}
                      isGetting={isFetching}
                      trailLength={trailLength}
                      companyId={companyId}
                      submitAgreement={submitAgreement}
                      isSubmitting={isSubmitting}
                      submitSuccess={submitSuccess}
                      getUserTrail={getUserTrail}
                
                    />
                  )}
                  {!singleDocName && posLength > 1 && (
                    <POSSingle
                      trails={trail}
                      isGetting={isFetching}
                      trailLength={trailLength}
                      companyId={companyId}
                      submitAgreement={submitAgreement}
                      isSubmitting={isSubmitting}
                      submitSuccess={submitSuccess}
                      getUserTrail={getUserTrail}
                
                    />
                  )}
                  {singleDocName === "POS" && (
                    <Cards
                      singleDoc={singleDoc}
                      isGettingCards={isGettingCards}
                      results={results}
                      showFrame={showFrame}
                      resultsLength={resultsLength}
                      testCardStatus={testCardStatus}
                    />
                  )}
                  {singleDocId && singleDocName !== "POS" && (
                    <Docs singleDoc={singleDoc} showFrame={showFrame} />
                  )}
                </>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getStatus: () => dispatch(getUserStatus()),
  getUserTrail: () => dispatch(getUserTrail()),
  getTestCards: () => dispatch(getTestCards()),
  submitAgreement: (payload) => dispatch(submitAgreement(payload)),
});

const mapStateToProps = (state) => {
  return {
    isGetting: state.docs.isGetting,
    dashboardData: state.docs.status,
    getStatusSuccess: state.docs.getStatusSuccess,
    isFetching: state.pos.isGettingTrail,
    success: state.pos.getUserTrailSuccess,
    userTrail: state.pos.userTrail,
    isSubmitting: state.testcases.isSubmittingAgreement,
    submitSuccess: state.testcases.submitAgreementStatus,
    cards: state.pos.cards,
    isGettingCards: state.pos.isGettingCards,
  

  };
};

SingleProductPage.propTypes = {
  cards: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  dashboardData: PropTypes.array,
  getStatus: PropTypes.func,
  getStatusSuccess: PropTypes.bool,
  getTestCards: PropTypes.func,
  getUserTrail: PropTypes.func,
  isFetching: PropTypes.bool,
  isGetting: PropTypes.bool,
  isGettingCards: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.any,
      name: PropTypes.string,
      posLength: PropTypes.any
    })
  }),
  submitAgreement: PropTypes.func,
  submitSuccess: PropTypes.bool,
  userTrail: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.any]),



}

export default connect(mapStateToProps, mapDispatchToProps)(SingleProductPage);
